module.exports = __webpack_public_path__ + "assets/b0edf97fcfc762b8e97e0d62f42c4854.json";